import { token as OriginToken } from '@atlaskit/tokens';

const Tokens = OriginToken;

export default Tokens;
